
import { Component, Vue } from 'nuxt-property-decorator'
import TheTrackingDataBreakers from '~/components/TheTrackingDataBreakers.vue'
import TheTrackingGtm from '~/components/TheTrackingGtm.vue'
import TheTrackingYottly from '~/components/TheTrackingYottly.vue'

@Component({
  components: {
    TheTrackingDataBreakers,
    TheTrackingGtm,
    TheTrackingYottly,
  },
})
export default class TheTracking extends Vue {
  // get isMarxyDisabled() {
  //   return (
  //     Cookies.get('SPA_MARXY_DISABLE') === '1' ||
  //     Cookies.get('NO_BANNERS') === '1' ||
  //     (this.$shopConfig.isBot === true &&
  //       this.$env?.isMarxyEnabledForBots === '0')
  //   )
  // }
}
